import { Component, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Table, TableLazyLoadEvent } from 'primeng/table'
import { concatMap, groupBy, of } from 'rxjs';
import { Localizacao } from 'src/app/core/models/localizacao.model';
import { Pedido } from 'src/app/core/models/pedido.model';
import { MeusPedidosRequest } from 'src/app/core/models/request/meus-pedidos-request.model';
import { LocalizacoesResponse } from 'src/app/core/models/response/localizacoes-response.model';
import { MeusPedidosResponse } from 'src/app/core/models/response/meus-pedidos-response.model';
import { WeblabService } from 'src/app/core/services/weblab.service';
import {jsPDF} from 'jspdf';
import { ProdutoResponse } from 'src/app/core/models/response/produto-response.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NovoPedidoRequest } from 'src/app/core/models/request/novo-pedido.request.model';
import { ClienteResponse } from 'src/app/core/models/response/cliente-response.model';
import { Medico, MedicoResponse } from 'src/app/core/models/medico.model';
import { DeviceService } from 'src/app/core/services/device.service';
import MobileDetect from 'mobile-detect';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-lista-pedidos',
  templateUrl: './lista-pedidos.component.html',
  styleUrls: ['./lista-pedidos.component.scss']
})
export class ListaPedidosComponent {
  @ViewChild('dt') dt: Table | undefined;

  pedidos: Pedido[] = [];
  first = 0;
  rows = 10;
  totalRecords = 10;
  loading: boolean = false;

  date: Date | null = null;
  dateEnd: Date | null = null;
  localizacoes: Localizacao[];
  datas: any[];
  filtros: any[];
  dataSelecionada: any;
  localizacaoSelecionada: Localizacao;
  filtroSelecionada: any;
  valorFiltro: any;
  linkSelecionado?: number;

  codigoLab: number;
  codigoCliente: number;
  decricao_produto: string;
  downloadingPDF: boolean = false;

  isMobile: boolean;

  filtro_mobile: boolean = false;

  modalVisualizarPedido: boolean = false;
  loadingVisualizarPedido: boolean = false;
  pedidoVisualizado: Pedido | null = null;
  dadosVisualizacao: any = null;
  medicoVisualizado: Medico | null = null;
  produtosVisualizados: any[] = [];
  anexosVisualizados: any[] = [];

  public tiposMontagemForm = [
    { id: 1, nome: 'Aro fechado' },
    { id: 2, nome: 'Meio Aro (Fio de Nylon)' },
    { id: 3, nome: 'Três peças (Balgriff)' },
    { id: 4, nome: 'Esportiva' }
  ];

  public listagemTipoMontagem = [
    {id: 1, tipo:'ARO FECHADO'},
    {id: 2, tipo:'MEIO ARO (FIO DE NYLON)'},
    {id: 3, tipo:'TRÊS PEÇAS (BALGRIFF)'},
    {id: 4, tipo:'ESPORTIVAS (CURVADAS)'}
  ];

  constructor(private service: WeblabService, private _sanitizer: DomSanitizer, private deviceService: DeviceService, private route: ActivatedRoute, private router: Router, private toastr: ToastrService) { }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();

    this.date = new Date(moment().subtract(30, 'days').format());
    this.dateEnd = new Date(moment().format());

    this.datas = [
      { id: 0, nome: 'Selecione', api: '' },
      { id: 1, nome: 'Data', api: 'data_venda' },
      { id: 2, nome: 'Previsão', api: 'previsao_entrega' },
      { id: 3, nome: 'Entrega', api: 'data_entrega' },
    ];

    this.dataSelecionada = this.datas[1];

    this.filtros = [
      { id: 1, nome: 'Cliente', api: 'cliente' },
      { id: 2, nome: 'Número OS', api: 'numero_os' },
      { id: 3, nome: 'CNPJ', api: 'cnpj' },
    ];

    // Verifica os parâmetros da url para iniciar a tela já filtrando
    this.route.queryParams.subscribe(params => {
      if (params['valor_filtro_data_inicial']) {
        this.date = new Date(params['valor_filtro_data_inicial']);
      }

      if (params['valor_filtro_data_final']) {
        this.dateEnd = new Date(params['valor_filtro_data_final']);
      }
    });

    setTimeout(() => {
      this.listaLocalizcoes();
    }, 2000);
  }

  listaLocalizcoes() {
    this.service.localizacoes().subscribe((response: LocalizacoesResponse) => {
      this.localizacoes = [];

      of(response.localizacoes).pipe(
        concatMap(res => res),
        groupBy(item => item.descricao_oticomlab),
        // mergeMap(group => zip(
        //   of(group.key), group.pipe(toArray())
        // ))
      ).subscribe((grouped: any) => {
        this.localizacoes.push({
          nome: grouped.key
        } as Localizacao)
      });
    });
  }

  async listaPedidos(event?: any) {
    this.loading = true;
    
    this.first = event?.first ?? 0;
    this.rows = event?.rows ?? this.rows ?? 10;

    const pagina = Math.floor(this.first / this.rows) + 1;

    const request: MeusPedidosRequest = {
      filtro_data: this.dataSelecionada?.api || undefined,
      valor_filtro_data_inicial: this.date ? moment(this.date).format('YYYY-MM-DD') : null,
      valor_filtro_data_final: this.dateEnd ? moment(this.dateEnd).format('YYYY-MM-DD') : null,
      limite: this.rows,
      pagina: pagina,
      filtro: this.filtroSelecionada?.api,
      valor_filtro: this.valorFiltro,
      localizacao: this.localizacaoSelecionada?.nome
    };

    this.loading = true;
    try {
      const pedidos: MeusPedidosResponse = await new Promise((resolve, reject) => this.service.meusPedidos(request).subscribe({ next: resolve, error: reject }));
      this.totalRecords = pedidos.paginacao?.total_registros ?? 0;

      this.pedidos = pedidos.dados.map((p) => {
        return {
          id: p.mov_tipo_nro,
          pedido_lab: p.pedido_lab,
          data: this.formatDate(p.data),
          solicitante: p.Cliente,
          os_otica: p.os_loja,
          paciente: p.paciente,
          previsao: this.formatDate(p.previsao),
          entrega: this.formatDate(p.entrega),
          status: p.localizacao,
          loja: p.loja,
          loja_id: p.loja_id,
          aprovado: (p.mov_baixado || "").trim().toUpperCase() == "S",
          tipo_pedido_lab: p.tipo_pedido_lab,
          nome_vendedor: p.nome_vendedor,
          valor: p.valor
        } as Pedido;
      })
    }
    catch(e) {
      if (e instanceof HttpErrorResponse && e.status === 404) {
        this.pedidos = [];
        this.totalRecords = 0;
      } else if (e instanceof HttpErrorResponse && e.status === 401) {
        // Autenticação encerrada pelo interceptor; a navegação para o login já foi feita.
      } else {
        this.toastr.error('Erro ao buscar pedidos.');
      }
    }

    this.loading = false;

    this.filtro_mobile = false;
  }

  async aplicarFiltros(event: any) {
    this.dataSelecionada = event.dataSelecionada;
    this.date = event.date;
    this.dateEnd = event.dateEnd;
    this.localizacoes = event.localizacoes;
    this.localizacaoSelecionada = event.localizacaoSelecionada;
    this.filtroSelecionada = event.filtroSelecionada;
    this.valorFiltro = event.valorFiltro;
    this.linkSelecionado = event.linkSelecionado;

    //Limpa os filtros da url
    // this.router.navigate([], {
    //   queryParams: {},
    //   queryParamsHandling: null
    // });

    await this.listaPedidos();
  }

  formatDate(date?: string): string {
    return date ? moment(date?.replace('T00:00:00Z', '')).format('DD/MM/yyyy') : '';
  }

  isLastPage(): boolean {
    return this.pedidos ? this.first === this.pedidos.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.pedidos ? this.first === 0 : true;
  }

  editar(pedido: Pedido) {

  }

  async visualizarPedido(pedido: Pedido) {
    this.pedidoVisualizado = pedido;
    this.dadosVisualizacao = null;
    this.medicoVisualizado = null;
    this.produtosVisualizados = [];
    this.anexosVisualizados = [];
    this.modalVisualizarPedido = true;
    this.loadingVisualizarPedido = true;

    try {
      const response: any = await new Promise((resolve, reject) => this.service.pedidoId(pedido.id, pedido.loja_id).subscribe({ next: resolve, error: reject }));
      const data = Array.isArray(response?.dados) ? response.dados[0] : null;
      this.dadosVisualizacao = data;

      if (data?.cod_medico) {
        this.medicoVisualizado = await this.buscarMedicoVisualizacao(data.cod_medico);
      }

      this.produtosVisualizados = (data?.carrinho || []).map((item: any) => {
        const subtotal_prod = parseFloat(item.subtotal_prod || 0);
        const vlr_venda_tratado = this.recuperarValor(subtotal_prod, item.quantidade, item.desc_acresc_porcentagem);

        return {
          codigo: item.cod_produto,
          descricao: item.produto_descricao,
          quantidade: item.quantidade,
          tipo_prod: item.uso_olho || '',
          vlr_venda_tratado,
          desc_acresc_porcentagem: item.desc_acresc_porcentagem,
          vlr_liquido_produto: item.quantidade > 0 ? (item.subtotal_prod / item.quantidade) : 0
        };
      });

      this.anexosVisualizados = (data?.anexos || []).map((anexo: any) => {
        const isImagem = (anexo.tipo_conteudo || '').startsWith('image/');
        const dataUrl = `data:${anexo.tipo_conteudo};base64,${anexo.conteudo}`;

        return {
          nome_arquivo: anexo.nome_arquivo,
          isImagem,
          url: this._sanitizer.bypassSecurityTrustUrl(dataUrl)
        };
      });
    }
    catch(e) {
      this.toastr.error('Erro ao buscar informações do pedido.');
      this.modalVisualizarPedido = false;
    }
    finally {
      this.loadingVisualizarPedido = false;
    }
  }

  private async buscarMedicoVisualizacao(cod_medico: any): Promise<Medico | null> {
    try {
      const response: MedicoResponse = await new Promise((resolve, reject) => this.service.buscarMedicoCod(cod_medico).subscribe({ next: resolve, error: reject }));
      return response?.dados?.find(m => m.id == cod_medico) || null;
    }
    catch(e) {
      return null;
    }
  }

  private recuperarValor(subtotal: number, quant: number, porcentagem: number): number {
    const fator = 1 - (porcentagem / 100);
    return subtotal / (quant * fator);
  }

  totalItensVisualizados(): number {
    return this.produtosVisualizados?.length ?? 0;
  }

  valorTotalVisualizado(): number {
    return this.produtosVisualizados
      .map(item => (item.vlr_liquido_produto ?? 0) * item.quantidade)
      .reduce((prev, curr) => prev + curr, 0);
  }

  tipoMontagemForm(tipo_id: any): string {
    const montagem = this.tiposMontagemForm.find(t => t.id == tipo_id);
    return montagem?.nome ?? '-';
  }

  fecharModalVisualizarPedido() {
    this.modalVisualizarPedido = false;
    this.pedidoVisualizado = null;
    this.dadosVisualizacao = null;
    this.medicoVisualizado = null;
    this.produtosVisualizados = [];
    this.anexosVisualizados = [];
  }

  pesquisarPedido(pedido: Pedido) {
    let pedidoSelecionado: NovoPedidoRequest;
    const lista = this.service.pedidoId(pedido.pedido_lab);
    lista.subscribe({
      next: (response) => {
        pedidoSelecionado = response;

        this.service.buscarClienteCod(pedidoSelecionado.cod_cliente).subscribe({
          next: (cliente: ClienteResponse) => {
            const clienteSelecionado = cliente.dados.filter(x => x.id === pedidoSelecionado.cod_cliente);  
            this.imprimirPdf(pedido, pedidoSelecionado, clienteSelecionado[0]);            
          },
        });

      }
    })     

  }

  logoLaboratorio() {
    let storageValue = localStorage.getItem('weblab_logo_lab'); 
    let logo = 'data:image/jpg;base64,' + storageValue;
    return logo
  }

  imprimirPdf(item: any,pedido: any, cliente: any) {
    const doc =  new jsPDF();
    // 1° quadro
    doc.roundedRect(10, 10, 190, 30, 2, 2); // 1° retangulo
    let logo = this.logoLaboratorio();
    doc.addImage(logo,'JPEG', 12.5, 12.5, 35, 25); // imagem (imageData, formato, x, y, width, height)

    const cam1linha1: number = 17;
    const cam1linha2: number = 26;
    const cam1linha3: number = 36;
    const cam2linha1: number = 52;
    const cam2linha2: number = 57;
    const cam2linha3: number = 62;
    const cam3linha1: number = 78;
    const cam3linha2: number = 84;
    const camInt1titulo: number = 91;
    const camInt1linha1: number = 98;
    const camInt1linha2: number = 104;
    const camInt1linha3: number = 110;
    const camInt2titulo: number = 118;
    const camInt2linha1: number = 125;
    const camInt2linha2: number = 130;
    const tituloSpec: number = 175;
    const tituloSpec2: number = 75;
    const desc1Spec: number = 182;
    const desc1Spec2: number = 82;
    const desc2Spec: number = 189;
    const desc3Spec: number = 196;
    const desc4Spec: number = 203;
    // 1° linha
    doc.setFont('Helvetica');
    doc.setFontSize(8);    
    doc.text(`${item.laboratorio}`, 50, cam1linha1);
    doc.setFont('Helvetica','','bold');
    doc.setFontSize(8);
    doc.text('Pedido Lab:', 142, cam1linha1);
    doc.setTextColor(135,17,17);
    doc.text(item.pedido_lab ? item.pedido_lab : '-', 160, cam1linha1, {maxWidth:40});

    // 2° linha
    doc.setFontSize(8);
    doc.setTextColor(0,0,0);
    
    doc.setFont('Helvetica','','bold');
    doc.text('Data do período:', 50, cam1linha2);
    doc.setFont('Helvetica','','normal');
    doc.text(item.data ? item.data : '-', 75, cam1linha2);
    doc.setFont('Helvetica','','bold');
    doc.text('Previsão entrega:', 142, cam1linha2);
    doc.setFont('Helvetica','','normal');
    doc.text(item.previsao ? item.previsao : '-', 168, cam1linha2);

    // 3° linha
    doc.setFont('Helvetica','','bold');
    doc.setTextColor(255,9,9);
    doc.text(`VENDA - ${item.status}`, 50, cam1linha3);
    doc.setTextColor(0,0,0);
    doc.text('Entrega efetiva:', 142, cam1linha3);
    doc.setFont('Helvetica','','normal');
    doc.text(item.entrega ? item.entrega : '-', 168, cam1linha3);

    // 2° quadro
    doc.roundedRect(10, 45, 190, 20, 2, 2); // 2° retangulo
    doc.setFillColor(255,255,255); // cor retangulo branco
    doc.rect(15, 42.5, 30, 5,'F'); // retangulo branco
    doc.setFont('Helvetica','','bold');
    doc.setTextColor(135,17,17);
    doc.text('Dados da Loja', 18, 46);
    // 1° linha
    doc.setTextColor(0,0,0);
    doc.text('Cliente', 15, cam2linha1);
    doc.setFont('Helvetica','','normal');
    // doc.text(item.paciente ? item.paciente : '-', 30, cam2linha1);
    doc.setFont('Helvetica','','bold');
    doc.text('Telefone', 128, cam2linha1);
    doc.text('Celular', 155, cam2linha1);
    doc.text('OS', 187, cam2linha1);
    // 2° linha
    doc.setFont('Helvetica','','normal');
    // doc.text(cliente.cod_cliente ? cliente.cod_cliente.toString() : '-', 18, cam2linha2);
    doc.text(cliente.nome_fantasia_social ? cliente.nome_fantasia_social : '-', 18, cam2linha2);
    doc.text(cliente.telefone ? cliente.telefone : '-', 128, cam2linha2);
    doc.text(cliente.celular ? cliente.celular : '-', 155, cam2linha2);
    doc.setFont('Helvetica','','bold');
    doc.text('Cliente', 185, cam2linha2);
    // 3° linha
    doc.text('Endereço:', 15, cam2linha3);
    doc.setFont('Helvetica','','normal');
    const endereco = cliente.endereco ? cliente.endereco : '-';
    const numero = cliente.numero ? cliente.numero : '-';
    const complemento = cliente.complemento ? cliente.complemento : '-';
    const bairro = cliente.bairro ? cliente.bairro : '-';
    const cidade = cliente.cidade ? cliente.cidade : '-';
    const estado = cliente.estado ? cliente.estado : '-';
    const enderecoCompleto = `${endereco}, ${numero}, ${complemento}, ${bairro}, ${cidade} / ${estado}`;
    doc.text(`${enderecoCompleto}`, 30, cam2linha3);
    doc.text(item.os_otica ? item.os_otica : '-', 185, cam2linha3);

    if(item.os_otica != null) {
      // 3° quadro
      doc.roundedRect(10, 70, 190, 71, 2, 2); // 3° retangulo
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(15, 67.5, 30, 5,'F'); // retangulo branco
      doc.setFont('Helvetica','','bold');
      doc.setTextColor(135,17,17);
      doc.text('Dados da receita', 18, 71);
      // 1° linha
      doc.setTextColor(0,0,0);
      doc.setFont('Helvetica','','bold');
      doc.text('Paciente:', 15, cam3linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(item.paciente ? item.paciente : '-', 30, cam3linha1);
      // 2° linha
      doc.setFont('Helvetica','','bold');
      doc.text('Data da receita:', 157, cam3linha2);
      doc.setFont('Helvetica','','normal');
      let dataFormatada = this.formatDate(pedido.data_insert);
      doc.text(dataFormatada ? dataFormatada : '-', 180, cam3linha2);
      // 1° quadro interno
      doc.roundedRect(15, 90, 180, 22, 2, 2); // retangulo interno
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(20, 88, 10, 5,'F'); // retangulo branco
      doc.setFont('Helvetica','','bold');
      doc.setTextColor(25,9,175);
      doc.text('Longe', 21, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(57, 88, 9, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Perto', 58, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(92, 88, 19, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Dist. Pupilar', 93, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(115, 88, 16, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Alt. Pupila', 116, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(135, 88, 26, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Prisma horizontal', 136, camInt1titulo);
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(165, 88, 25, 5,'F'); // retangulo branco
      doc.setTextColor(25,9,175);
      doc.text('Prisma vertical', 168, camInt1titulo);
      // 1° linha
      doc.setTextColor(0,0,0);
      doc.setFontSize(6); 
      doc.text('Esf.', 28, camInt1linha1);
      doc.text('Cil.', 36, camInt1linha1);
      doc.text('Eixo', 42, camInt1linha1);
      doc.text('DNP', 49, camInt1linha1);
      doc.text('Adição', 56, camInt1linha1);
      doc.text('Esf.', 64, camInt1linha1);
      doc.text('Cil.', 71, camInt1linha1);
      doc.text('Eixo', 78, camInt1linha1);
      doc.text('DNP', 84, camInt1linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(pedido.Receita?.distancia_pupilar ? pedido.Receita?.distancia_pupilar.toString() : '-', 100, camInt1linha1);
      doc.setFont('Helvetica','','bold');
      doc.text('Valor', 138, camInt1linha1);
      doc.text('Base', 150, camInt1linha1);
      doc.text('Valor', 168, camInt1linha1);
      doc.text('Base', 180, camInt1linha1);

      doc.line(25,100,190,100);
      doc.line(25,106,190,106);
      // doc.line(25,94,25,112);
      doc.line(54.5,94,54.5,112);
      doc.line(90,94,90,112);
      doc.line(113,94,113,112);
      doc.line(133,94,133,112);
      doc.line(163,94,163,112);
      // 2° linha
      doc.setFontSize(8); 
      doc.text('OD', 20, camInt1linha2);
      doc.setFont('Helvetica','','normal');
      doc.setFontSize(6); 
      doc.text(pedido.Receita?.longe_esferico_olho_direito ? pedido.Receita?.longe_esferico_olho_direito.toString() : '-', 28, camInt1linha2);
      doc.text(pedido.Receita?.longe_cilindrico_olho_direito ? pedido.Receita?.longe_cilindrico_olho_direito.toString() : '-', 35, camInt1linha2);
      doc.text(pedido.Receita?.longe_eixo_olho_direito ? pedido.Receita?.longe_eixo_olho_direito.toString() : '-', 42, camInt1linha2);
      doc.text(pedido.Receita?.longe_dnp_olho_direito ? pedido.Receita?.longe_dnp_olho_direito.toString() : '-', 49, camInt1linha2);
      doc.text(pedido.Receita?.adicao_olho_direito ? pedido.Receita?.adicao_olho_direito.toString() : '-', 56, camInt1linha2);
      doc.text(pedido.Receita?.perto_esferico_olho_direito ? pedido.Receita?.perto_esferico_olho_direito.toString() : '-', 64, camInt1linha2);
      doc.text(pedido.Receita?.perto_cilindrico_olho_direito ? pedido.Receita?.perto_cilindrico_olho_direito.toString() : '-', 71, camInt1linha2);
      doc.text(pedido.Receita?.perto_eixo_olho_direito ? pedido.Receita?.perto_eixo_olho_direito.toString() : '-', 78, camInt1linha2);
      doc.text(pedido.Receita?.perto_dnp_olho_direito ? pedido.Receita?.perto_dnp_olho_direito.toString() : '-', 84, camInt1linha2);
      doc.text(pedido.Receita?.altura_pupila_olho_direito ? pedido.Receita?.altura_pupila_olho_direito.toString() : '-', 122.5, camInt1linha2);
      doc.text(pedido.Receita?.prisma_valor_horizontal_od ? pedido.Receita?.prisma_valor_horizontal_od.toString() : '-', 140, camInt1linha2);
      doc.text(pedido.Receita?.prisma_base_horizontal_od ? pedido.Receita?.prisma_base_horizontal_od.toString() : '-', 150, camInt1linha2);
      doc.text(pedido.Receita?.prisma_valor_vertical_od ? pedido.Receita?.prisma_valor_vertical_od.toString() : '-', 170, camInt1linha2);
      doc.text(pedido.Receita?.prisma_base_vertical_od ? pedido.Receita?.prisma_base_vertical_od.toString() : '-', 180, camInt1linha2);
      // 3° linha
      doc.setFont('Helvetica','','bold');
      doc.setFontSize(8); 
      doc.text('OE', 20, camInt1linha3);
      doc.setFont('Helvetica','','normal');
      doc.setFontSize(6); 
      doc.text(pedido.Receita?.longe_esferico_olho_esquerdo ? pedido.Receita?.longe_esferico_olho_esquerdo.toString() : '-', 28, camInt1linha3);
      doc.text(pedido.Receita?.longe_cilindrico_olho_esquedo ? pedido.Receita?.longe_cilindrico_olho_esquedo.toString() : '-', 35, camInt1linha3);
      doc.text(pedido.Receita?.longe_eixo_olho_esquerdo ? pedido.Receita?.longe_eixo_olho_esquerdo.toString() : '-', 42, camInt1linha3);
      doc.text(pedido.Receita?.longe_dnp_olho_esquerdo ? pedido.Receita?.longe_dnp_olho_esquerdo.toString() : '-', 49, camInt1linha3);
      doc.text(pedido.Receita?.adicao_olho_esquedo ? pedido.Receita?.adicao_olho_esquedo.toString() : '-', 56, camInt1linha3);
      doc.text(pedido.Receita?.perto_esferico_olho_esquerdo ? pedido.Receita?.perto_esferico_olho_esquerdo.toString() : '-', 64, camInt1linha3);
      doc.text(pedido.Receita?.perto_cilindrico_olho_esquerdo ? pedido.Receita?.perto_cilindrico_olho_esquerdo.toString() : '-', 71, camInt1linha3);
      doc.text(pedido.Receita?.perto_eixo_olho_esquerdo ? pedido.Receita?.perto_eixo_olho_esquerdo.toString() : '-', 78, camInt1linha3);
      doc.text(pedido.Receita?.perto_dnp_olho_esquerdo ? pedido.Receita?.perto_dnp_olho_esquerdo.toString() : '-', 84, camInt1linha3);
      doc.text(pedido.Receita?.altura_pupila_olho_esquerdo ? pedido.Receita?.altura_pupila_olho_esquerdo.toString() : '-', 122.5, camInt1linha3);
      doc.text(pedido.Receita?.prisma_valor_horizontal_oe ? pedido.Receita?.prisma_valor_horizontal_oe.toString() : '-', 140, camInt1linha3);
      doc.text(pedido.Receita?.prisma_base_horizontal_oe ? pedido.Receita?.prisma_base_horizontal_oe.toString() : '-', 150, camInt1linha3);
      doc.text(pedido.Receita?.prisma_valor_vertical_oe ? pedido.Receita?.prisma_valor_vertical_oe.toString() : '-', 170, camInt1linha3);
      doc.text(pedido.Receita?.prisma_base_vertical_oe ? pedido.Receita?.prisma_base_vertical_oe.toString() : '-', 180, camInt1linha3);
      // 2° quadro interno
      doc.roundedRect(15, 117, 180, 18, 2, 2); // retangulo interno
      doc.setFontSize(8); 
      doc.setFillColor(255,255,255); // cor retangulo branco
      doc.rect(20, 115, 27, 5,'F'); // retangulo branco
      doc.setFont('Helvetica','','bold');
      doc.setTextColor(25,9,175);
      doc.text('Dados da armação', 21, camInt2titulo);
      doc.setTextColor(0,0,0);
      doc.text('Ponte', 22, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(pedido.Receita?.ponte ? pedido.Receita?.ponte.toString() : '-', 24, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Aro', 42, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(pedido.Receita?.aro ? pedido.Receita?.aro.toString() : '-', 43, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Alt. Vertical', 59, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(pedido.Receita?.mov_alt_vertical ? pedido.Receita?.mov_alt_vertical.toString() : '-', 65, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Diag.Maior', 88, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(pedido.Receita?.diagonal_maior ? pedido.Receita?.diagonal_maior.toString() : '-', 94, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Diâm. Apurado', 120, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.text(pedido.Receita?.diametro_apurado ? pedido.Receita?.diametro_apurado.toString() : '-', 127, camInt2linha2);
      doc.setFont('Helvetica','','bold');
      doc.text('Tipo de montagem', 158, camInt2linha1);
      doc.setFont('Helvetica','','normal');
      doc.setFontSize(6); 
      doc.text(pedido.Receita?.tipo_montagem ? this.tipoMontagem(pedido.Receita?.tipo_montagem) : '-', 159, camInt2linha2);

      doc.setFont('Helvetica','','bold');
      doc.setFontSize(8);
      doc.text('Observações', 10, 148);
      // doc.text('Observações', 110, 148);
      doc.setFont('Helvetica','','normal');
      doc.text(pedido.Receita?.observacao ? pedido.Receita?.observacao : '-', 10, 155, {maxWidth:90});
      // doc.text(pedido.Receita?.observacao ? pedido.Receita?.observacao : '-', 110, 155, {maxWidth:90});

      doc.setFont('Helvetica','','bold');
      // doc.text('Esp', 10, tituloSpec);
      doc.text('Olho', 10, tituloSpec);
      doc.text('Item', 20, tituloSpec);
      doc.text('UN', 155, tituloSpec);
      doc.text('Qtde', 170, tituloSpec);
      doc.text('Subtotal', 185, tituloSpec);
      doc.line(10,177,200,177); // linha
      
      let qttd = 0;
      for (let i = 0; i < pedido.carrinho.length; i++) {
        let item = i * 7;
        let linha = desc1Spec + item;
        doc.setFont('Helvetica','','normal');
        // doc.text(pedido.carrinho[i].uso_olho ? 'L' : 'M', 10, linha);
        doc.text(pedido.carrinho[i].uso_olho ? pedido.carrinho[i].uso_olho : '-', 10, linha);
        doc.text(pedido.carrinho[i].produto_descricao ? pedido.carrinho[i].produto_descricao : '-', 22, linha);
        doc.text('PC', 155, linha);
        doc.text(pedido.carrinho[i].quantidade ? pedido.carrinho[i].quantidade.toFixed(2) : '-', 170, linha);
        let formattedSubValor = pedido.carrinho[i].subtotal_prod.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        doc.text(`R$ ${formattedSubValor}`, 185, linha); 
        
        doc.line(10,184,200,184); // linha
        doc.line(10,191,200,191); // linha    
        qttd += pedido.carrinho[i].quantidade;    
      }

      let totalLinha = (pedido.carrinho.length * 10) + 179;
      // doc.line(10,198,200,198); // linha
      doc.setFont('Helvetica','','bold');
      doc.text('Totais:', 130, totalLinha);
      doc.text(qttd.toFixed(2).toString(), 170, totalLinha);
      let formattedValorT= pedido.valor_venda.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      doc.text(`R$ ${formattedValorT}`, 185, totalLinha);

    } else {
      doc.setFont('Helvetica','','bold');
      // doc.text('Esp', 12, tituloSpec2);
      doc.text('Olho', 12, tituloSpec2);
      doc.text('Item', 22, tituloSpec2);
      doc.text('UN', 157, tituloSpec2);
      doc.text('Qtde', 172, tituloSpec2);
      doc.text('Subtotal', 187, tituloSpec2);
      doc.line(12,77,200,77); // linha
  
      let qttd2 = 0;
      for (let i = 0; i < pedido.carrinho.length; i++) {
        let item = i * 7;
        let linha = desc1Spec2 + item;
        doc.setFont('Helvetica','','normal');
        // doc.text('L', 12, linha);
        doc.text(pedido.carrinho[i].uso_olho ? pedido.carrinho[i].uso_olho : '-', 12, linha);
        doc.text(pedido.carrinho[i].produto_descricao ? pedido.carrinho[i].produto_descricao : '-', 24, linha);
        doc.text('PC', 157, linha);
        doc.text(pedido.carrinho[i].quantidade ? pedido.carrinho[i].quantidade.toFixed(2) : '-', 172, linha);
        let formattedSubValor = pedido.carrinho[i].subtotal_prod.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        doc.text(`R$ ${formattedSubValor}`, 187, linha); 
        
        doc.line(12,84,200,84); // linha
        // doc.line(12,91,200,91); // linha

        if(i >= 2 ) {
          doc.line(12,84 + 7,200,84 + 7); // linha
          doc.line(12,91 + 7,200,91 + 7); // linha
        }        
  
        qttd2 += pedido.carrinho[i].quantidade;  
      }
      let totalLinha = (pedido.carrinho.length * 7) + desc1Spec2;
      // doc.line(12,98,200,98); // linha
      doc.setFont('Helvetica','','bold');
      doc.text('Totais:', 132, totalLinha);
      doc.text(qttd2.toFixed(2).toString(), 172, totalLinha);
      let formattedValorT= pedido.valor_venda.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      doc.text(`R$ ${formattedValorT}`, 187, totalLinha);
    }

    this.downloadingPDF = false;
    let nomeArquivo = `PEDIDO-${item.pedido_lab}`
    doc.save(`${nomeArquivo}.pdf`);
    
  }
  
  tipoMontagem(tipo_id: any) {
    let montagem = this.listagemTipoMontagem.filter(x => x.id.toString().includes(tipo_id.toString()));
    return montagem[0].tipo;
  }

}